/* Maison Lalla — scheda prodotto: galleria a scorrimento */
(function () {
  var r = document.querySelector('[data-mlp]');
  if (!r) return;
  var stage = r.querySelector('[data-media-stage]');
  var slides = Array.prototype.slice.call(r.querySelectorAll('[data-media-slide]'));
  var thumbs = Array.prototype.slice.call(r.querySelectorAll('.mlp__thumb'));
  var counter = r.querySelector('[data-mlp-counter-current]');
  var zoom = r.querySelector('[data-zoom]');
  var modal = r.querySelector('[data-modal]');
  var mq = window.matchMedia('(max-width: 800px)');
  var current = 0;
  function setActive(i) {
    if (i < 0 || i >= slides.length) return;
    current = i;
    slides.forEach(function (slide, j) {
      var on = j === i;
      slide.classList.toggle('active', on);
      if (!on) slide.querySelectorAll('video').forEach(function (video) { try { video.pause(); } catch (e) {} });
    });
    thumbs.forEach(function (thumb, j) { thumb.classList.toggle('active', j === i); });
    if (counter) counter.textContent = String(i + 1);
    if (zoom) zoom.style.display = slides[i] && slides[i].dataset.mediaType === 'image' ? 'block' : 'none';
  }
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var i = parseInt(thumb.dataset.mediaIndex, 10) || 0;
      setActive(i);
      if (mq.matches && stage) stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    });
  });
  if (stage) {
    stage.addEventListener('scroll', function () {
      if (!mq.matches || !stage.clientWidth) return;
      var i = Math.round(stage.scrollLeft / stage.clientWidth);
      if (i !== current) setActive(i);
    }, { passive: true });
  }
  var heroImg = r.querySelector('#mlpHero');
  if (heroImg && window.MutationObserver) {
    new MutationObserver(function () {
      setActive(0);
      if (stage && mq.matches) stage.scrollTo({ left: 0, behavior: 'auto' });
    }).observe(heroImg, { attributes: true, attributeFilter: ['src'] });
  }
  setActive(0);
  if (zoom && modal) {
    zoom.addEventListener('click', function () {
      var img = slides[current] && slides[current].querySelector('img');
      if (img) { modal.querySelector('img').src = img.currentSrc || img.src; modal.classList.add('open'); }
    });
    var close = r.querySelector('[data-close]');
    if (close) close.addEventListener('click', function () { modal.classList.remove('open'); });
    modal.addEventListener('click', function (event) { if (event.target === modal) modal.classList.remove('open'); });
  }
})();